import { useMutation, useQueryClient } from "@tanstack/react-query";
import { toast } from "react-toastify";
import { setDefaultMeetingNotesTemplate } from "../api/meetingNotesTemplates";

export const useSetDefaultMeetingNotesTemplate = () => {
  const queryClient = useQueryClient();

  const { mutate: setDefaultMeetingNotesTemplateMutate, isLoading } =
    useMutation({
      mutationFn: (templateId) => setDefaultMeetingNotesTemplate(templateId),
      onSuccess: () => {
        queryClient.invalidateQueries({
          queryKey: ["meeting-notes-templates"],
        });
        toast.success("Default template updated");
      },
      onError: () => {
        toast.error(
          "There was a problem setting the default template. Please try again.",
        );
      },
    });

  return { setDefaultMeetingNotesTemplateMutate, isLoading };
};
